export const mergeSpendMaps = (a = {}, b = {}) => {
  const merged = { ...a };
  Object.entries(b).forEach(([currency, amount]) => {
    merged[currency] = (Number(merged[currency]) || 0) + Number(amount);
  });
  return merged;
};

export const sumPortfolioBuckets = (slice = []) =>
  slice.reduce(
    (acc, bucket) => ({
      impressions: acc.impressions + (Number(bucket.impressions) || 0),
      clicks: acc.clicks + (Number(bucket.clicks) || 0),
      mainAction: acc.mainAction + (Number(bucket.mainAction) || 0),
      spend: mergeSpendMaps(acc.spend, bucket.spend),
    }),
    { impressions: 0, clicks: 0, mainAction: 0, spend: {} }
  );
